<script lang="ts">
	export let fill = "#6d6f76";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 60 60">
	<g>
		<g>
			<path
				d="M74.472 278.455a30 30 0 1 0 30 30 30 30 0 0 0-30-30zm18.252 31.176-17.052.024.028 17.045a1.2 1.2 0 0 1-2.4 0l-.024-17.04-17.052.024a1.2 1.2 0 0 1 0-2.4l17.052-.024-.028-17.06a1.2 1.2 0 1 1 2.4 0l.024 17.052 17.04-.024a1.2 1.2 0 0 1 .012 2.4z"
				transform="translate(-44.472 -278.455)"
				style={`fill:${fill}`} />
		</g>
	</g>
</svg>

<style lang="scss">
	path {
		transition: fill 0.5s;
	}

</style>
